module.exports = __webpack_public_path__ + "img/birmingham-city.872f977d.png";